import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: window.location.host === 'sspai.com' ? 'https://sspai.com/api/v1' : 'https://neo.sspai.com/api/v1'
})

service.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem('ssToken')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.error !== 0) {
      console.log(response.data)
    }
    return response.data
  },
  (error) => {
    return Promise.reject(error)
  }
)
export default service
